import React from 'react';
import _ from 'lodash';

import config from 'app.config';

const { reactAppEnv } = config;
const marqueeText = _.times(3, function (i) {
  return `THIS IS ${reactAppEnv} ENVIRONMENT 這是${reactAppEnv}環境`;
}).join(' ');

export default function Marquee() {
  return reactAppEnv !== 'production' ? (
    <div id="marquee">
      <div>
        <span>{marqueeText}</span>
      </div>
    </div>
  ) : null;
}
